import { createSlice } from '@reduxjs/toolkit';

import { IProjectsItem, IProjectsState } from './interfaces';
import { loadProjectsItem, loadProjectsList } from './actions';

export const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IProjectsState,
  reducers: {
    clearProjectsItemData: state => {
      state.item = {} as IProjectsItem;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      loadProjectsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadProjectsItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});

export const { clearProjectsItemData } = projectsSlice.actions;
